import React from 'react';
import { DownloadIcon, PrinterIcon } from 'lucide-react';
export type LegalLanguage = 'English' | 'Kinyarwanda' | 'French';
const languages: {
  id: LegalLanguage;
  short: string;
}[] = [{
  id: 'English',
  short: 'EN'
}, {
  id: 'Kinyarwanda',
  short: 'RW'
}, {
  id: 'French',
  short: 'FR'
}];
type LegalHeaderProps = {
  title: string;
  lastUpdated?: string;
  version?: string;
  language: LegalLanguage;
  onLanguageChange: (language: LegalLanguage) => void;
};
export function LegalHeader({
  title,
  lastUpdated,
  version,
  language,
  onLanguageChange
}: LegalHeaderProps) {
  return <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-704" data-mp="2lg3rhukt77wi">
      <div data-id="element-705" data-mp="2lhwqqot3epuh">
        <p className="text-[14px] font-semibold text-brand" data-id="element-706" data-mp="2gh91o8ofcj2w">Legal</p>
        <h1 className="display mt-3 text-[34px] font-semibold text-ink sm:text-[46px]" data-id="element-707" data-mp="2gj3oxtn64na5">{title}</h1>
        {lastUpdated && <p className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-[14px] text-ink-muted" data-id="element-708" data-mp="2php0h4u8321f">
            <span data-id="element-709" data-mp="pb98zfaj0zuo">Last updated: {lastUpdated}</span>
            <span aria-hidden="true" data-id="element-710" data-mp="pckebjjmefnw">·</span>
            <span data-id="element-711" data-mp="u9uarj5ffrl8">Version {version}</span>
          </p>}
      </div>

      <div className="flex flex-wrap items-center gap-3 print:hidden" data-id="element-712" data-mp="uc6thyj0e5zc">
        <div role="radiogroup" aria-label="Document language" className="flex rounded-[8px] border border-canvas-line bg-white p-0.5" data-id="element-713" data-mp="z7m32e9zhfpy">
          {languages.map(lang => {
          const active = lang.id === language;
          return <button key={lang.id} type="button" role="radio" aria-checked={active} aria-label={lang.id} onClick={() => onLanguageChange(lang.id)} className={`h-9 min-w-[44px] rounded-[6px] px-2.5 text-[13px] font-semibold transition-colors duration-150 ease-out ${active ? 'bg-ink text-white' : 'text-ink-muted hover:text-ink'}`} data-id="element-714" data-mp="1d8yf4em0wx6k">
                {lang.short}
              </button>;
        })}
        </div>
        <a href="#" className="inline-flex h-10 items-center gap-2 rounded-[7px] border border-ink/20 bg-white px-3.5 text-[14px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45" data-id="element-715" data-mp="3sxpry6vm17yx">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-716" data-mp="v8gjfdfpnjx" />
          Download PDF
        </a>
        <button type="button" onClick={() => window.print()} aria-label="Print this page" className="flex h-10 w-10 items-center justify-center rounded-[7px] border border-ink/20 bg-white text-ink transition-colors duration-150 ease-out hover:border-ink/45" data-id="element-717" data-mp="fk4l32ga8ifs">
          <PrinterIcon className="h-4 w-4" aria-hidden="true" data-id="element-718" data-mp="kllksun15yus" />
        </button>
      </div>
    </div>;
}